export enum TradingViewTimeframesEnum {
	oneMinute = '1',
	threeMinutes = '3',
	fiveMinutes = '5',
	fifteenMinutes = '15',
	thirtyMinutes = '30',
	oneHour = '60',
	twoHours = '120',
	threeHours = '180',
	fourHours = '240',
	oneDay = '1D',
	oneWeek = '1W',
	oneMonth = '1M',
	oneYear = '12M',
}
